import React from 'react';
import { Route } from 'react-router-dom';

import UsersGrid from './UsersGrid';
import UsersForm from './UsersForm';

/**
 * Contenedor de Users. La RUTA decide qué se monta (no un flag isDetail):
 *  - /Users           → lista (UsersGrid)
 *  - /Users/:userName → formulario (UsersForm)
 * El `key` fuerza re-montar el form al cambiar de usuario.
 */
export default function Users(props) {
  const nivel = props.nivel;

  return (
    <>
      <Route exact path="/Users"
        render={() => <UsersGrid nivel={nivel} />} />

      <Route path="/Users/:userName"
        render={({ match }) => (
          <UsersForm
            key={match.params.userName}
            nivel={nivel}
            userName={match.params.userName}
          />
        )} />
    </>
  );
}
